// All of these are stackFileNames that don't relate to a saved stack

import { strings, utilityFileNames } from "@quickpoint.me/shared";

export const utilityFileNameMessage: {
  [key in typeof utilityFileNames[number]]: string;
} = {
  [strings.common.unauthorized]: "title: Are you logged in?",
  [strings.unset]: "title: Hi, \nYou currently have no presentation open.\nPlease open an existing one or create a new one.\n",
  [strings.utility.alreadyAuth]: "title: Please open a presentation. Press the presentations button. ",
  [strings.utility.badUrl]: "title: Bad Url, Bad Url \nlook up.. look up",
  [strings.utility.emailLinkExpired]:
    "title: Expired \nThis email link expired. We sent you a new one. \n Please click it soon. ",
  [strings.utility.loginError]:
    "title: There was a problem. \nAre you logged in. Try again? \nDo you have an account? \nYou can sign up below.",
  [strings.utility.noOwnerNameAssociatedWithEmail]:
    "title: There was a problem. \nDo you have an account name registered? \nYou can register one here",
  [strings.utility.networkError]: "title: Is your connection ok? \nThis is weird - please refresh your browser",
  [strings.utility.postLogin]: "title: Hello and welcome",
  [strings.utility.signedUp]: "title: Check your email to verify your address for us to let you login.",
  [strings.utility.signUpTime]:
    "title: Sign Up Time!\nYou will need to provide a unique organization name. I'll prompt you if the one you use is taken",
  [strings.utility.unverifiedEmail]: "title: You need to verify your email",
};
